export interface Config {
  app: string;
  tenantId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>;
  theme: {
    logo: {
      lg: string;
      xs: string;
    };
    favicon: string;
  };
  languages: {
    default: string;
    available: string[];
  };
  env: {
    SENTRY_DSN?: string;
    SENTRY_ENV?: string;
    SENTRY_RELEASE?: string;
    MSW_MOCKING: string;
  };
  endpoints: {
    api: string;
    apiGraphQL: string;
    apiWebsocket: string;
  };
}
export const wf = ((window as any).__workflows as Config);
if (!wf) {
  throw new Error("Failed to load bootstrapping config.");
}

// Endpoints
if (!wf.endpoints || !wf.endpoints.apiWebsocket || !wf.endpoints.apiGraphQL || !wf.endpoints.api) {
  throw new Error("Failed to set up API connection due to missing endpoint URLs. " + "Make sure you set up your environment correctly.");
}
if (!wf.languages || !wf.languages.available || !wf.languages.default) {
  console.warn("Failed to set up Translations due to incomplete or missing languages config. " + "Make sure you have correctly added languages config for this tenant in your database");
}
export const config: Config = {
  app: wf.app,
  env: wf.env,
  data: wf.data,
  endpoints: wf.endpoints,
  tenantId: wf.tenantId,
  theme: wf.theme,
  languages: wf.languages
};
export const data = wf.data;
export const endpoints: Config["endpoints"] = wf.endpoints;
export const theme: Config["theme"] = wf.theme;
export const tenantId = wf.tenantId;